function initCookiePopup() {
  const $popup = $('.js-cookie-popup');
  const delay = 3 * 1000;
  const cookieKey = 'acceptCookiePolicy';
  if(hasCookie() || !$popup.length) return


  setTimeout(() => {
      $popup.addClass('_active')
  }, delay);

  $popup.find('.js-accept-cookie').on('click', function() {
      addCookie()
      $popup.removeClass('_active');
  });

  function addCookie() {
      document.cookie = `${cookieKey}=true; path=/; expires=Fri, 25 Jun 2038 05:24:33 GMT`
  }

  function hasCookie() {
      const value = document.cookie.split('; ').find((i) => i.startsWith(cookieKey))
      return value === `${cookieKey}=true`
  }
}
